function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#eceff1",
  d: "M44.5,39h-41C3.225,39,3,38.775,3,38.5v-29C3,9.225,3.225,9,3.5,9h41C44.775,9,45,9.225,45,9.5v29 C45,38.775,44.775,39,44.5,39z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#cfd8dc",
  d: "M16 9H18V39H16zM30 9H32V39H30z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#cfd8dc",
  d: "M23 -2H25V40H23z",
  transform: "rotate(-90 24 19)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#cfd8dc",
  d: "M23 8H25V50H23z",
  transform: "rotate(-90 24 29)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#dd2c00",
  d: "M44,38c-12-8-13.193-25-19-25S18,30,4,38H44z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#304ffe",
  d: "M4,38h37c-18.584,0-18.193-23-24-23c-3,0-4.441,7.102-6,11C7,36,4,38,4,38z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#64dd17",
  d: "M4,38h40c-3.484-2.279-5.516-13-9-13c-3,0-4,5-6,5s-4.579-9-8-9C16.354,21,12,37,4,38z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#cfd8dc",
  d: "M44.5,40h-41C2.673,40,2,39.327,2,38.5v-29C2,8.673,2.673,8,3.5,8h41C45.327,8,46,8.673,46,9.5v29 C46,39.327,45.327,40,44.5,40z M4,38h40V10H4V38z"
});

const SvgHistogram = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHistogram, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/histogram.42c5490e.svg";
export { ForwardRef as ReactComponent };